module.exports = __webpack_public_path__ + "static/media/br-ac.92e7adde.svg";